import { useState, useEffect, useRef } from "react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalEvenStructureItem,
  FestivalEventStructureTable,
  FestivalEventStructureHeader,
  FestivalEvenStructureItemBrake,
  FestivalEvenStructureItemWrapper,
} from "./style";
import { TournamentStructure } from "../../../../../../../api/types";
import {
  FestivalEventITMBack,
  FestivalEventITMHeader,
  FestivalEventITMWrapper,
} from "../itm/style";

const RabbitFestivalEventStructure = () => {
  const { event } = useRabbitFestivalContext();
  const [list, setList] = useState<TournamentStructure[]>([]);
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open ? contentRef.current.scrollHeight + 56 + 20 : 56);
    }
  }, [open]);

  useEffect(() => {
    if (!event) return;
    setList(event.tournament.structure);
  }, [event]);

  return (
    <FestivalEventITMWrapper contentHeight={contentHeight}>
      <FestivalEventITMHeader onClick={() => setOpen(!open)} open={open}>
        <div className="title">스트럭쳐</div>
        <img src="image-web/rabbit/down_arrow.svg" alt="more" />
      </FestivalEventITMHeader>
      <FestivalEventITMBack open={open} ref={contentRef}>
        <FestivalEventStructureTable>
          <FestivalEventStructureHeader>
            <div className="level">LV</div>
            <div className="blind">SB</div>
            <div className="blind">BB</div>
            <div className="item">ANTE</div>
            <div className="item">TIME</div>
          </FestivalEventStructureHeader>
          <FestivalEvenStructureItemWrapper>
            {list.map((item, index) =>
              item.type === "LEVEL" ? (
                <FestivalEvenStructureItem key={index}>
                  <div className="level">{item.level}</div>
                  <div className="blind">
                    {item.smallBlind?.toLocaleString()}
                  </div>
                  <div className="blind">{item.bigBlind?.toLocaleString()}</div>
                  <div className="item">{item.ante?.toLocaleString()}</div>
                  <div className="item">{item.time}</div>
                </FestivalEvenStructureItem>
              ) : (
                <FestivalEvenStructureItemBrake key={index}>
                  <div className="item">BREAK {item.time} MIN</div>
                </FestivalEvenStructureItemBrake>
              )
            )}
          </FestivalEvenStructureItemWrapper>
        </FestivalEventStructureTable>
      </FestivalEventITMBack>
    </FestivalEventITMWrapper>
  );
};

export default RabbitFestivalEventStructure;
